import { useState, useRef } from 'react';
import { NudosButton, NudosGenericModal } from '../../../NudosComponents';
import { BordLogo } from '../../../../assets/images/services';
import { CloseIcon } from '../../../../assets/images/bussines';
import { generateIndividualQrPDF, downloadPDF } from '../../../../utils/pdfGeneration';

import './PrintableModal.scss';

type PrintableModalProps = {
  qrCode: string;
  qrData?: IQRData;
  closeModal?: () => void;
};

interface IQRData {
  serial?: string | number | null;
  orgName?: string | null;
  productId?: string | number | null;
}

const PrintableModal: React.FC<PrintableModalProps> = ({ qrCode, qrData, closeModal }) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const targetRef = useRef<HTMLDivElement>(null);
  const svgContent = `${qrCode}`;

  const handleDownloadPDF = async () => {
    if (!targetRef.current || isGenerating) return;

    setIsGenerating(true);
    
    // Ocultar temporalmente el elemento durante la generación
    const originalDisplay = targetRef.current.style.display;
    targetRef.current.style.display = 'none';
    
    try {
      // Mostrar el elemento brevemente para que se renderice correctamente
      targetRef.current.style.display = 'block';
      await new Promise(resolve => setTimeout(resolve, 100)); // Pequeña pausa para el renderizado
      
      const pdfBlob = await generateIndividualQrPDF(targetRef.current);
      const filename = `${qrData?.productId}-${qrData?.serial || ''}.pdf`;
      downloadPDF(pdfBlob, filename);
    } finally {
      // Restaurar el estado original del elemento
      targetRef.current.style.display = originalDisplay;
      setIsGenerating(false);
    }
  };

  return (
    <NudosGenericModal
      modalContent={
        <div className="printableModalContainer">
          <div className="closeButtonContainer">
            <div className="closeButton" onClick={closeModal}>
              <CloseIcon />
            </div>
          </div>
          <div className="printableTicketContainer" ref={targetRef}>
            <div className="logoContainer">
              <img src={BordLogo} alt="Bord Logo" />
            </div>
            <div dangerouslySetInnerHTML={{ __html: svgContent }} />
            <div className="printableTicketInfoContainer">
              <div className="serialText">
                Serial:<strong> {qrData?.serial || 'N/A'} </strong>
              </div>
              <div className="spaceConatiner">
                <div className="grayLine" />
              </div>
              <div className="printableTicketInfoText">
                Empresa: <strong> {qrData?.orgName || 'N/A'}</strong>
              </div>
              <div className="printableTicketInfoText">
                Product ID:<strong> {qrData?.productId || 'N/A'}</strong>
              </div>
            </div>
          </div>
          <NudosButton 
            buttonText={isGenerating ? "Generando..." : "Imprimir"} 
            handleClick={handleDownloadPDF}
            isButtonDisabled={isGenerating}
          />
        </div>
      }
    />
  );
};

export default PrintableModal;
